import React from 'react';
import { observer } from 'mobx-react';
import Sidebar from './sidebar/Sidebar';
import ActiveConversation from './active-conversation/ActiveConversation';
import { isMobileOnly } from 'react-device-detect';

import { RootStoreContext } from '../../../context';

import './Chat.css';
import '../../../css/utils/flex.css';

@observer
class Chat extends React.Component {

  static contextType = RootStoreContext;

  componentDidMount () {
    this.context.privateMessagingStore.attachGlobalRosterListener();
    this.context.privateMessagingStore.loadPrivateChatData();
  }

  render () {
    const { privateMessagingStore: { displaySidebar } } = this.context;
    let className = '';
    if (!isMobileOnly) {
      className += ' flex';
    }
    if (displaySidebar) {
      className += ' with-sidebar';
    } else {
      className += ' no-sidebar';
    }
    return (
      <div id="private-chat" className={className}>
        <Sidebar/>
        <ActiveConversation />
      </div>
    );
  }
}

export default Chat;